export enum ReferralStatus {
  Pending = 0,
  Accepted = 1,
  Rejected = 2
}
